// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__KKfsp","upload":"Small_upload__3Noqu","imageWrap":"Small_imageWrap__3Mc4a","removeBtn":"Small_removeBtn__syK6Q"};